import { hot } from 'react-hot-loader/root';
import Component from './setNewPassword-redux';

export default hot(Component);
